// API endpoints mapping
export const ENDPOINTS = {
  // Auth
  LOGIN: 'users/login',
  
  // Systems
  GET_ALL_SYSTEMS: 'api/systems/',
  SYSTEM_CHANGE_ENABLED: 'api/systems/toggle-enabled',
  DELETE_SYSTEM: 'api/systems/delete',
  ADD_SYSTEM: 'api/systems/add',
  EDIT_SYSTEM: 'api/systems/edit',
  GET_SYSTEM_INFO: (systemName) => `api/systems/${systemName}/info`,
  
  // Inputs
  INPUTS_DATA: 'api/inputs/data',
  
  // Simulation
  GENERATE_IMAGE: 'api/generate_image',
  GRAPHIC_GENERATOR: 'graphic_generator',
  SIMULATION_STATUS: (id) => `api/simulation/status/${id}`,
  
  // Admin
  ADMIN_LIST: 'api/admin/list',
  ADMIN_ADD: 'api/admin/add',
  ADMIN_DELETE: 'api/admin/delete',
  ADMIN_CHECK: 'api/admin/check',
  
  // Videos
  VIDEO_UPLOAD: 'api/videos/upload',
  VIDEO_LIST: 'api/videos/list',
  VIDEO_DELETE: 'api/videos/delete',
  VIDEO_STREAM: (name) => `api/videos/${name}`,
  
  // Analytics
  ANALYTICS_DATA: 'api/analytics/data',
  ANALYTICS_EXPORT: 'api/analytics/export',
  ANALYTICS_SUMMARY: 'api/analytics/summary',
  ANALYTICS_SIMULATION_DATA: 'api/analytics/simulation-data',
  
  // Legacy (temporary - remove after frontend updates)
  LEGACY_INPUTS: 'inputs_data',
  LEGACY_LOGIN: 'users/login',
  LEGACY_SYSTEMS: 'get_all_systems',
};